module.exports = __webpack_public_path__ + "static/social-8df49ee6d3fa3484e5a4a88206c5b657.jpg";